import { useContext, useEffect, useMemo, useState } from "react";
import { ChoreographicCreation } from "../../../../../generated/data-contracts";
import { CreationType } from "../../../../../models";
import { api } from "../../../../../utils";
import { AvisLoader } from "../../../../shared/components";
import {
  AvisField,
  AvisGrid,
  AvisSection,
  AvisTitleAndSubtitle,
} from "../../../../shared/components/form";
import { AvisContext } from "../../../../shared/context/AvisContext";
import {
  CreationBands,
  CreationNames,
  CreationNumbers,
  CreationOtherInfo,
  CreationRightsHolders,
} from "../sections";
import { CreationBasePage, ICreationBasePageProps } from "./CreationBasePage";

export function CreationPageChoreographic(
  props: Readonly<ICreationBasePageProps>,
) {
  const { urlParams, setError } = props;
  const { res } = useContext(AvisContext);
  const [creationInfo, setCreationInfo] = useState<
    ChoreographicCreation | undefined
  >();
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const getCreationInfo = useMemo(() => {
    if (!urlParams.rightsHolderId) return;
    if (!urlParams.creationId) return;
    setIsLoading(true);

    api
      .rightsHoldersGetChoreographicCreation(
        urlParams.rightsHolderId,
        urlParams.creationId,
      )
      .then((res) => setCreationInfo(res.data))
      .catch(setError)
      .finally(() => setIsLoading(false));
  }, [urlParams, setError]);

  useEffect(() => {
    getCreationInfo;
  }, [getCreationInfo]);
  if (isLoading) return <AvisLoader inline />;

  return (
    <CreationBasePage data={creationInfo} {...props}>
      <AvisTitleAndSubtitle title={creationInfo?.creationName} />
      <AvisSection>
        <AvisGrid>
          <AvisField
            title={res("authors_Creation_label_AKKACode")}
            value={creationInfo?.creationNumber}
          />
          <AvisField
            title={res("authors_Creation_label_Timing")}
            value={creationInfo?.timings}
          />
        </AvisGrid>
      </AvisSection>
      <CreationRightsHolders
        data={creationInfo?.rightsHolders}
        creationType={creationInfo?.creationClassCode as CreationType}
      />
      <CreationBands data={creationInfo?.creationBands} />
      <CreationNames data={creationInfo?.creationNameValues} />
      <CreationNumbers data={creationInfo?.creationNumberValues} />
      <CreationOtherInfo
        creationRegistered={creationInfo?.creationDate}
        creationStatus={creationInfo?.creationStatusNamePortal}
        musicalCreationName={creationInfo?.musicalCreationName}
        statusNotes={creationInfo?.statusNotes}
      />
    </CreationBasePage>
  );
}
